import axios from 'axios';
import api from '../../../utils/api';

export default {
  async fetchInvoiceByCompanyId(_, id) {
    const { data } = await axios(api.invoice.fetchInvoiceByCompanyId(id));
    return data;
  },
  async fetchInvoiceById({}, invoiceId) {
    const { data } = await axios(api.invoice.fetchInvoiceById(invoiceId));
    return data;
  },
  async updatePaymentStatus({}, updatedInfo) {
    const { data } = await axios(api.invoice.updatePaymentStatus(updatedInfo));
    return data;
  },
  async getPaymentAccount({}, invoice) {
    const { data } = await axios(api.invoice.getPaymentAccount(invoice));
    return data;
  },
  async changeInvoiceTransaction({}, transactionData) {
    const { data } = await axios(api.invoice.changeInvoiceTransaction(transactionData));
    return data;
  },
  async createStripeTransaction({}, invoice) {
    const { data } = await axios(api.invoice.createStripeTransaction(invoice));
    const { intent } = data;
    return intent;
  },
  async getStripeIntent({}, invoice) {
    const { data } = await axios(api.invoice.getStripeIntent(invoice));
    return data;
  },
  async getPaymentSteps(_, invoice) {
    const { data } = await axios(api.invoice.getPaymentSteps(invoice));
    return data.results;
  },
  async getInvoiceParticipants(_, id) {
    const { data } = await axios(api.invoice.getInvoiceParticipants(id));
    return data.results;
  },
};
